module.exports = __webpack_public_path__ + "static/media/SHUBHAM SIR 001 .23f0bcae.jpg";